import { Base } from "./Base";

export class Finished extends Base {
    constructor(public contestantState) {
        super(contestantState);
        this.STATE_LEVEL = 7;
    }

    public getActiveTitle() {
        return "none";
    }

    public showSignedUpTitle() {
        return this.contestantState === this.CONTESTANT_STATE_FINISHED;
    }

    public getNotSignedUpTemplates() {
        return ["Information"];
    }

    public getSignedUpTemplates() {
        return ["Information"];
    }

    public getFinishedTemplates() {
        return ["Information", "Result"];
    }

    // For continuing ladders with seasons
    public getPlayingTemplates() {
        return ["Information", "Result"];
    }
}
